import { render, staticRenderFns } from "./PropertyDocumentGrid.vue?vue&type=template&id=56dd4f9f&"
import script from "./PropertyDocumentGrid.vue?vue&type=script&lang=js&"
export * from "./PropertyDocumentGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports